class AjaxForm {
  constructor() {
    const forms = document.querySelectorAll(".mc-ajax")
    this.ping = this.ping.bind()
    if (forms) {
      forms.forEach((container) => {    
        const form = container.querySelector(".mc-ajax-form")
        this.ping(form)
      })
    }
  }
  ping(el) {
      const gdprCheck = el.querySelector('.newsletter-privacy-policy')
      //const submitBtns = document.querySelectorAll('.newsletter-signup-submit')

      gdprCheck.addEventListener("click", (e) => {
          let submitBtn = el.querySelector('.newsletter-signup-submit');
          submitBtn.disabled = submitBtn.disabled == true ? false : true;
      }) 

      el.addEventListener("submit", (e) => {
        
        e.preventDefault()

        //to reveal
        const p = e.target.closest(".mc-ajax")
        const rev = p.querySelector(".mc-ajax-response")
        const err = p.querySelector(".mc-ajax-error")

        err.querySelector('.m-exists').classList.add('d-none');
        err.querySelector('.m-error').classList.remove('d-none');

        const name = el.querySelector('#mc-name').value
        const email = el.querySelector('#mc-email').value
        const company = el.querySelector('#mc-company').value

        //setup form data for WP Ajax function
        const formData = new FormData()
        formData.append("action", "aw_chimp_subscribe")
        formData.append("name", name)
        formData.append("email", email)
        formData.append("company", company)

        //fetch
        fetch(`/wp/wp-admin/admin-ajax.php`, {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            if (response.ok) {
              return response.json()
            }
            else {
              return {
                'error':true
              }
            }
          })
          .then((data) => {
            console.log(data);
            if (data.error) {
              
              err.classList.remove("d-none")
              if (data.error == 'exists') {
                err.querySelector('.m-exists').classList.remove('d-none');
                err.querySelector('.m-error').classList.add('d-none');
                //err.querySelector('.m-exists').innerHTML = data.error;
              }
            }
            else {
              err.classList.add("d-none")
              el.classList.add("d-none") 
              rev.classList.remove("d-none")
 
              if (typeof ga === 'function') {
                  ga('gtm4.send', 'event', 'Form Submit', 'Newsletter Signup', window.location);
              }
            }
            
            
          })
          .catch((error) => console.log(error))
      })
  }
  getArgs(postList) {
    return {
      postList: postList,
      nextPage: postList.dataset.next,
      postType: postList.dataset.type,
      postCat: postList.dataset.category,
      perPage: postList.dataset.perpage,
    } 
  }
  loadPage(args) {}
}

export default new AjaxForm()
